export const fhbLangCn = {
    ticketFhb: {
        usePage: "应用页面",
        verifyDistribution: "电核分配",
        urgeDistribution: "催收分配",
        staffMaxDailyWorkingNumber: "每日最大处理工单量",
        ticketMaxWorkingNumber: "员工每日最大负载量",
        ticketPartialCompletedWorkloadFactor: "部分完成工单在计算负载时占的百分比",
        ticketID: "Ticket ID",
        verifyCompleteTime: "工单处理时间",
        ticketHandle: "处理工单",
        ticketList: "工单列表",
        waitingProcess: "待处理",
        partialCompleted: "部分完成",
        phoneVerifyDistribution: "电核分单",
        distributionManagement: "分单管理",
        phoneVerify: "电核",
        stopAcceptTicket: "停止接单",
        continueAcceptTicket: "开始接单",
        qualityInspectionResults: "质检结果",
        auditResults: "审核结果",
        creditReviewResults: "信审结果",
        auditType: "审核类型",
        createTime: "创建时间",
        TicketCategory: "信审工单类型",
        IndividualDeductibleAmount: "该单个人可减免金额",
        GroupDeductibleAmount: "该单组可减免金额"
    },
    menuFhb: {
        creditApprovalTicketHandle: "信审工单处理",
        auditStaffManagement: "电核工单管理",
        ticketHandle: "工单处理",
        qualityInspectionTicketHandle: "质检工单处理",
        workOrderProcessingList: "工单处理"
        
    },
    robotFhb: {
        taskManagement: "任务管理",
        robotService: "机器人任务",
        robot: "机器人",
        employeeType: "员工类别",
        remainingToBeRepaidAmount: "剩余未还金额",
        taskName: "任务名称",
        stratetyName: "策略名称",
        startTime: "开始时间",
        Time: "开始时间-结束时间",
        operator: "创建人",
        timeSlot: "时间段",
        executionTime:"执行时间",
        morning: "上午",
        afternoon: "下午",
        details: "详情",
        DistinguishingMode: "区分方式"
    },
    messageFhb: {
        selectLanguage: "请选择语言"
    }
};
